var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, FieldText, FlexBox, FormField, FormGrid, Icon, Page, Text, } from '@dixa/lib-shared-habla';
import { client as elevioClient } from 'elevio';
import { Controller, useForm } from 'react-hook-form';
import { chatbotsApi } from 'apis/chatbots';
import { NotificationType, useNotifications } from 'hooks/useNotifications';
import { isResponseWithData } from 'utils/apis/axios';
import { articles } from 'utils/elevio';
import { useAppNavigate } from 'utils/url/useAppNavigate';
import { SettingsIntegrationsDocumentationButton } from '../../../../components/documentationButton/documentationButton';
import { defaultChatbotName, pathToChatbotsSettings, } from '../../chatbots.view';
import styles from './chatbotsCreate.view.module.scss';
/** Solvemate Chatbots but perhaps this can be extended in the future. */
export const ChatbotsCreateView = () => {
    const navigate = useAppNavigate();
    const notify = useNotifications();
    const [createChatbot] = chatbotsApi.useCreateChatbotMutation();
    const { control, handleSubmit } = useForm({
        defaultValues: {
            url: '',
        },
    });
    const onSubmit = ({ url }) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const response = yield createChatbot({
            url,
            // Currently we only support Solvemate as 'type'
            _type: 'solvemate-from-url',
        }).unwrap();
        if (isResponseWithData(response)) {
            notify({
                title: 'Success',
                text: `"${((_a = response.data) === null || _a === void 0 ? void 0 : _a.name) || defaultChatbotName}" has been created.`,
                icon: 'i-done',
                time: 5000,
            }, NotificationType.Success);
            navigate({ path: pathToChatbotsSettings });
        }
        else {
            notify({
                title: 'Error while creating the chatbot.',
            }, NotificationType.Error);
        }
    });
    return (_jsxs(_Fragment, { children: [_jsx(Page.Section, Object.assign({ title: "Create chatbot", titleMeta: _jsx(SettingsIntegrationsDocumentationButton, { onClick: () => elevioClient.openArticle(articles.settings.chatbots.documentation) }), controls: _jsx(Button, Object.assign({ onClick: handleSubmit(onSubmit) }, { children: "Save changes" })) }, { children: _jsx("form", Object.assign({ onSubmit: handleSubmit(onSubmit) }, { children: _jsx(FormGrid, { children: _jsx(FormField, Object.assign({ span: 4 }, { children: _jsx(Controller, { name: "url", control: control, rules: {
                                    required: {
                                        value: true,
                                        message: 'This field is required',
                                    },
                                    pattern: {
                                        // Checks if the string contains '/chatbot/123456abc'
                                        value: /.*\/chatbot\/([0-9a-z]+).*/,
                                        message: 'This does not look like a Solvemate URL',
                                    },
                                }, render: ({ field, fieldState }) => {
                                    var _a;
                                    return (_jsx(FieldText, { required: true, label: "Solvemate URL", input: field, placeholder: "Insert your Solvemate URL", meta: {
                                            warning: (_a = fieldState === null || fieldState === void 0 ? void 0 : fieldState.error) === null || _a === void 0 ? void 0 : _a.message,
                                        } }));
                                } }) })) }) })) })), _jsx(Page.Section, { children: _jsxs(FlexBox, Object.assign({ flexDirection: "column", gap: "300" }, { children: [_jsx(Text.Paragraph, { children: "To integrate the chatbot, your Solvemate's chatbot URL is needed!" }), _jsx(Text.Paragraph, { children: "You can find it by going to your Solvemate chatbot dashboard and copy the URL from the browser address bar and paste it in the input below." }), _jsxs(FlexBox, Object.assign({ display: "inline-flex", flexDirection: "row", gap: "250", margin: "300 0", className: styles.solvemateExampleLink }, { children: [_jsx(Icon, { name: "lock", size: 20 }), _jsx(Box, Object.assign({ className: styles.solvemateExampleLinkLabel }, { children: "https://app.solvemate.com/org/1234567890/chatbot/1234567890/dashboard" }))] }))] })) })] }));
};
